import React from 'react';
import { makeStyles } from "@utilities/theme_utilities";
import Grid from '@mui/material/Grid2';
import { ColorsType } from '../../../DandDPalette';

interface Props {
  name: string;
  value: boolean;
  disabled?: boolean;
  color?: string;
  colors?: ColorsType;
  image?: string;
  tooltip?: string;
  style?: React.CSSProperties | undefined;
  borderless?: boolean;
  onToggle?: (() => void) | null; 
  matchButtonBox?: boolean;
}

export default function ToggleButtonBox({
  name,
  value,
  disabled = false,
  color = "",
  colors,
  image = "",
  tooltip = "",
  style = {},
  borderless = false,
  onToggle = null,
  matchButtonBox = false
}: Props) {

  const useStyles = makeStyles()((theme) => {
    let useBGColor = theme.palette.primary.dark;
    let useColor = theme.palette.primary.main;
    if (colors) {
      if (colors.backgroundColor !== "") {
        useBGColor = colors.backgroundColor;
      }
      if (colors.color && colors.color !== "" && colors.color !== "Default") {
        useColor = colors.color;
      }
    } else if (color !== "") {
      useBGColor = color;
    }
    return ({
      root: {
        color: useColor,
        borderColor: useColor,
        lineHeight: matchButtonBox ? 2.5 : undefined,
        // backgroundColor: theme.palette.primary.dark,
        '&:hover': {
          // color: useColor,
          backgroundColor: useBGColor,
        },
        '&.true': {
          // color: useColor,
          backgroundColor: useBGColor,
        }
      },
    });
  });
  
  const className = matchButtonBox ? `centered labs_button${disabled ? " disabled" : ""}` : `centered toggle_button ${value ? "true" : ""}${disabled ? " disabled" : ""}${borderless ? " borderless" : ""}`;
  const { classes, cx } = useStyles();

  const use_style = Object.keys(style).length > 0 ? style : {
    width: "100%"
  };

  //Thanks to cx, className will take priority over classes.root
  if (matchButtonBox) {
    return (
      <div className="centered"
        style={{
          width: "100%"
        }}>
        <div style={use_style} 
          className={cx(classes.root, className)} 
          onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            if (!disabled && onToggle) {
              onToggle();
            }
          }}>
          <Grid container spacing={0} direction="column">
            <Grid>
              { image === "" ? 
                <span>{ name }</span> 
              : 
                <img src={ image } alt={ name }
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%"
                  }} 
                />
              }
            </Grid>
          </Grid>
        </div>
      </div>
    );
  } else {
    return (
      <div title={tooltip}>
        <div
          className={cx(classes.root, className)} 
          style={style}
          onClick={() => {
            if (!disabled && onToggle) {
              onToggle();
            }
          }}>
          { image === "" ? 
            <span>{ name }</span> 
          : 
            <img src={ image } alt={ name }
              style={{
                maxWidth: "100%",
                maxHeight: "100%"
              }} 
            />
          }
        </div>
      </div>
    );
  }
}
